export default "__VITE_ASSET__BmqjtmzU__"